export default __webpack_public_path__ + "img/3.94fbfb9f.jpg";